import { render, staticRenderFns } from "./Knowlarity.vue?vue&type=template&id=974332dc"
import script from "./Knowlarity.vue?vue&type=script&lang=js"
export * from "./Knowlarity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports